export const CreateCitationPanelId = 'create-citation-panel'
export const ExpertCheckPanelId = 'expert-check-panel'
export const ExpertCheckContainerPanelId = 'expert-check-panel-container'
